"use client"
import React from 'react'
import { usePathname } from 'next/navigation'
import { useConfig } from '@/contexts/config-context'
import { FaTiktok, FaFacebook, FaInstagram } from 'react-icons/fa'

import { Box, IconButton, Typography } from '@mui/material'


export default function Footer() {
    let configData = useConfig();
    const pathname = usePathname();

    const redirectToPage = (url) => window.open(url, '_blank');

    const redirectToWhatsapp = () => {
        window.open(`https://wa.me/55${configData.phone}?text=Olá, vim pelo site ${configData.name} e gostaria de mais informações`);
    }

    const shouldRenderBottom = () => {
        return pathname == "/" || pathname.indexOf("/raffle/") != -1;
    }


    if (!configData?.facebook && !configData?.instagram && !configData?.tiktok) {
        return <></>
    }

    return (
        <Box sx={{
            textAlign: "center",
            mt: 2,
        }}>
            <Typography variant='body2'>Acompanhe nossas redes sociais</Typography>
            <Box display="flex" justifyContent={"center"} gap={2} mt={1}>
                {
                    configData?.facebook && <IconButton onClick={() => redirectToPage(configData.facebook)}><FaFacebook style={{ fontSize: 30, color: '#1877F2' }} /></IconButton>
                }
                {
                    configData?.instagram && <IconButton onClick={() => redirectToPage(configData.instagram)}><FaInstagram style={{ fontSize: 30, color: '#E1306C' }} /></IconButton>
                }
                {
                    configData?.tiktok && <IconButton onClick={() => redirectToPage(configData.tiktok)}><FaTiktok style={{ fontSize: 30, color: 'black' }} /></IconButton>
                }
            </Box>
            {
                shouldRenderBottom() &&
                <div style={{
                    position: "relative",
                    bottom: 0,
                    backgroundColor: `${configData?.appearance?.client_primary_color ?? 'black'}`,
                    width: "100%",
                    color: "white",
                    textAlign: "center",
                    paddingTop: 10,
                    paddingBottom: 10,
                    fontSize: 14
                }}>Desenvolvido por <span onClick={redirectToWhatsapp} style={{ textDecoration: 'underline', cursor: "pointer", fontWeight: 'bold' }}>{configData?.developed_by ?? "Atlas Vision"}</span></div>
            }
        </Box>
    )
}
